export default __webpack_public_path__ + "static/FundamentalsofAIinEducation(Microcredential)-55b11279b561977edc525783f8659c51.mp3";